import { createSelector } from '@ngrx/store';
import { blockedPhoneNumberRegisterSelector } from './blocked-phone-number-register.reducer';

export const selectFilters = createSelector(blockedPhoneNumberRegisterSelector, (state) => {
   return state.filters;
});
